'use client';

import React, { useState } from 'react';
import { usePathname } from 'next/navigation';
import Header from './Header';
import Sidebar from './Sidebar';

export default function LayoutWrapper({ children, interClass }) {
  const pathname = usePathname();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  // If we are on the login page (or any route starting with /auth etc if added later), 
  // don't show the dashboard layout.
  const isLoginPage = pathname === '/';

  if (isLoginPage) {
    return <div className={interClass}>{children}</div>;
  }

  return (
    <div className={`${interClass} flex min-h-screen overflow-hidden`}>
      {/* Sidebar - Client Component */}
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      {/* Drawer Boundary Toggle Trigger */}
      <button
        onClick={toggleSidebar}
        className={`fixed top-[18px] z-[100] p-1.5 bg-[#4f5a50] text-white rounded-md border border-white/20 shadow-2xl transition-all duration-300 hover:scale-110 active:scale-95 group ${
          isSidebarOpen ? 'left-[272px]' : 'left-[64px] max-lg:-left-full'
        }`}
        aria-label={isSidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
      >
        {isSidebarOpen ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
          </svg>
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>

      {/* Main Content Area */}
      <div className={`flex flex-col flex-1 min-w-0 ${isSidebarOpen ? 'lg:pl-72' : 'lg:pl-20'} transition-all duration-300`}>
        {/* Header - Client Component */}
        <Header onMenuClick={toggleSidebar} />

        {/* Content Area - This will render Server Component children */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
